module.exports = __webpack_public_path__ + "static/media/onepage-bg-left.c83dc045.jpg";